import { Pipe, PipeTransform } from '@angular/core';
import { ColumnOrder, ColumnOrderEnum } from '@core/table/order';

@Pipe({ name: 'pagination', pure: false })
export class PaginationPipe implements PipeTransform {
  transform(arrayData: any, page: any, itens: any, columnOrder?: string | ColumnOrder): any {

    if (!Array.isArray(arrayData))
      return [];

    let array = [...arrayData];

    if (!Array.isArray(array)) {
      return;
    }

    if (!array.some(x => x?._originalIndex && x instanceof Object))
      array.forEach((val, i) => {

        Object.defineProperty(val, "_originalIndex", {
          enumerable: false,
          writable: true
        });
        val._originalIndex = i;
      })

    if (!columnOrder) {
      if (array.some(x => x._originalIndex))
        array = array.sort((a, b) => {
          if (a._originalIndex < b._originalIndex) {
            return -1;
          } else if (a._originalIndex > b._originalIndex) {
            return 1;
          } else {
            return 0;
          }
        });
    }

    if (columnOrder instanceof String) {
      array = array.sort((a: any, b: any) => {
        return a[columnOrder.toString()].trim().localeCompare(b[columnOrder.toString()].trim());
      });
    }

    if (columnOrder instanceof ColumnOrder && columnOrder.value) {
      array = array.sort((a: any, b: any) => {
        const aValue = this.deepFind(a, columnOrder.key);
        const bValue = this.deepFind(b, columnOrder.key);

        if (aValue === undefined || bValue === undefined) {
          return 0;
        }

        switch (columnOrder.value) {
          case ColumnOrderEnum.ascend:
            return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;

          case ColumnOrderEnum.descend:
            return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;

          default:
            return 0;
        }
      });
    }

    return array.slice((page - 1) * itens, page * itens);
  }

  deepFind(obj: any, path: string | undefined) {
    if (!path) {
      return undefined;
    }

    var paths = path.split('.')
      , current = obj
      , i;

    for (i = 0; i < paths.length; ++i) {
      if (current[paths[i]] == undefined) {
        return undefined;
      } else {
        current = current[paths[i]];
      }
    }
    return current;
  }
}
